import React from 'react';

const Close =() =>
    <svg className="closeIcon" xmlns="http://www.w3.org/2000/svg" width="27.421" height="27.642" viewBox="0 0 27.421 27.642">
    <g id="Group_13172" data-name="Group 13172" transform="translate(-109.599 -61.628)">
        <rect id="Rectangle_6453" data-name="Rectangle 6453" width="36" height="2.778" transform="translate(111.563 61.628) rotate(45)" fill="#1a1818"/>
        <rect id="Rectangle_6454" data-name="Rectangle 6454" width="36.001" height="2.778" transform="translate(137.021 63.814) rotate(135)" fill="#1a1818"/>
    </g>
    </svg>;

export default Close;